import { useEffect, useCallback } from 'react';
import json2mq from 'json2mq';
import useAssociativeArray from './useAssociativeArray';

const useMedia = (mediaQueries = {}, isServer, context) => {
  const { serverMedia = {} } = context;

  const matchMedia = useCallback(key => {
    const query = mediaQueries[key];
    return (
      typeof window !== 'undefined' &&
      window.matchMedia(typeof query === 'string' ? query : json2mq(query))
    );
  }, []);

  const [items, addItem] = useAssociativeArray({
    mediaQueries,
    matchMedia,
    mediaReady: false,
  });

  useEffect(() => {
    const disposeAll = Object.keys(mediaQueries).map(key => {
      const list = matchMedia(key);
      const listener = () => {
        if (list.matches) {
          addItem('device', key);
        }
        addItem('mediaReady', true);
        addItem(key, list.matches);
      };
      const dispose = () => list.removeListener(listener);

      list.addListener(listener);
      listener();

      return dispose;
    });

    return () => {
      disposeAll.forEach(dispose => dispose());
    };
  }, [addItem, matchMedia]);

  return isServer
    ? {
        mobile: false,
        tablet: false,
        desktop: false,
        ...serverMedia,
        mediaReady: false,
        matchMedia,
        mediaQueries,
      }
    : items;
};

export default useMedia;
